export const observeHubspotFormErrors = (formElement, onErrorFound) => {
    const observer = new MutationObserver((mutations) => {
        if (document.visibilityState === "hidden") return; // ignore when tab is inactive
        mutations.forEach(mutation => {
            // Check for new error elements added
            mutation.addedNodes.forEach(node => {
                if (
                    node.nodeType === 1 && // Element
                    (node.matches('.hs-error-msg, .hs-error-msgs') ||
                        node.querySelector('.hs-error-msg, .hs-error-msgs'))
                ) {
                    // console.warn('Validation error detected:', node);
                    onErrorFound(node);
                }
            });

            // Also check for visibility or text content changes in existing error nodes
            if (
                mutation.type === 'attributes' &&
                mutation.target.matches('.hs-error-msg, .hs-error-msgs') &&
                getComputedStyle(mutation.target).display !== 'none'
            ) {
                // console.warn('Validation error changed:', mutation.target);
                onErrorFound(mutation.target);
            }
        });
    });

    observer.observe(formElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
    });

    return observer;
};


// WEBPACK FOOTER //
// ./src/utils/hubspot.js